/******PageProjet******/

/*PAGE*/
export default function Newsletter() {
  /*DOM*/
  return (
    <>
      <meta charSet="UTF-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <title>Newsletter SNAP</title>

      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            "\n\t\tp{\n\t\t\tmargin:10px 0;\n\t\t\tpadding:0;\n\t\t}\n\t\ttable{\n\t\t\tborder-collapse:collapse;\n\t\t}\n\t\th1,h2,h3,h4,h5,h6{\n\t\t\tdisplay:block;\n\t\t\tmargin:0;\n\t\t\tpadding:0;\n\t\t}\n\t\timg,a img{\n\t\t\tborder:0;\n\t\t\theight:auto;\n\t\t\toutline:none;\n\t\t\ttext-decoration:none;\n\t\t}\n\t\tbody,#bodyTable,#bodyCell{\n\t\t\theight:100%;\n\t\t\tmargin:0;\n\t\t\tpadding:0;\n\t\t\twidth:100%;\n\t\t}\n\t\t.mcnPreviewText{\n\t\t\tdisplay:none !important;\n\t\t}\n\t\t#outlook a{\n\t\t\tpadding:0;\n\t\t}\n\t\timg{\n\t\t\t-ms-interpolation-mode:bicubic;\n\t\t}\n\t\ttable{\n\t\t\tmso-table-lspace:0pt;\n\t\t\tmso-table-rspace:0pt;\n\t\t}\n\t\t.ReadMsgBody{\n\t\t\twidth:100%;\n\t\t}\n\t\t.ExternalClass{\n\t\t\twidth:100%;\n\t\t}\n\t\tp,a,li,td,blockquote{\n\t\t\tmso-line-height-rule:exactly;\n\t\t}\n\t\ta[href^=tel],a[href^=sms]{\n\t\t\tcolor:inherit;\n\t\t\tcursor:default;\n\t\t\ttext-decoration:none;\n\t\t}\n\t\tp,a,li,td,body,table,blockquote{\n\t\t\t-ms-text-size-adjust:100%;\n\t\t\t-webkit-text-size-adjust:100%;\n\t\t}\n\t\t.ExternalClass,.ExternalClass p,.ExternalClass td,.ExternalClass div,.ExternalClass span,.ExternalClass font{\n\t\t\tline-height:100%;\n\t\t}\n\t\ta[x-apple-data-detectors]{\n\t\t\tcolor:inherit !important;\n\t\t\ttext-decoration:none !important;\n\t\t\tfont-size:inherit !important;\n\t\t\tfont-family:inherit !important;\n\t\t\tfont-weight:inherit !important;\n\t\t\tline-height:inherit !important;\n\t\t}\n\t\ttable[align=left]{\n\t\t\tfloat:left;\n\t\t}\n\t\ttable[align=right]{\n\t\t\tfloat:right;\n\t\t}\n\t\t#bodyCell{\n\t\t\tpadding:10px;\n\t\t\tborder-top:0;\n\t\t}\n\t\t.templateContainer{\n\t\t\tmax-width:600px !important;\n\t\t\tborder:0;\n\t\t}\n\t\ta.mcnButton{\n\t\t\tdisplay:block;\n\t\t}\n\t\t.mcnImage,.mcnRetinaImage{\n\t\t\tvertical-align:bottom;\n\t\t}\n\t\t.mcnTextContent{\n\t\t\tword-break:break-word;\n\t\t}\n\t\t.mcnTextContent img{\n\t\t\theight:auto !important;\n\t\t}\n\t\t.mcnDividerBlock{\n\t\t\ttable-layout:fixed !important;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Background Style\n\t@tip Set the background color and top border for your email. You may want to choose colors that match your company's branding.\n\t*/\n\t\tbody,#bodyTable{\n\t\t\t/*@editable*/background-color:#ececec;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Background Style\n\t@tip Set the background color and top border for your email. You may want to choose colors that match your company's branding.\n\t*/\n\t\t#bodyCell{\n\t\t\t/*@editable*/border-top:0;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Email Border\n\t@tip Set the border for your email.\n\t*/\n\t\t.templateContainer{\n\t\t\t/*@editable*/border:0;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Heading 1\n\t@tip Set the styling for all first-level headings in your emails. These should be the largest of your headings.\n\t@style heading 1\n\t*/\n\t\th1{\n\t\t\t/*@editable*/color:#21759c;\n\t\t\t/*@editable*/font-family:'Helvetica Neue', Helvetica, Arial, Verdana, sans-serif;\n\t\t\t/*@editable*/font-size:26px;\n\t\t\t/*@editable*/font-style:normal;\n\t\t\t/*@editable*/font-weight:bold;\n\t\t\t/*@editable*/line-height:125%;\n\t\t\t/*@editable*/letter-spacing:normal;\n\t\t\t/*@editable*/text-align:left;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Heading 2\n\t@tip Set the styling for all second-level headings in your emails.\n\t@style heading 2\n\t*/\n\t\th2{\n\t\t\t/*@editable*/color:#202020;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:22px;\n\t\t\t/*@editable*/font-style:normal;\n\t\t\t/*@editable*/font-weight:bold;\n\t\t\t/*@editable*/line-height:125%;\n\t\t\t/*@editable*/letter-spacing:normal;\n\t\t\t/*@editable*/text-align:left;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Heading 3\n\t@tip Set the styling for all third-level headings in your emails.\n\t@style heading 3\n\t*/\n\t\th3{\n\t\t\t/*@editable*/color:#202020;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:20px;\n\t\t\t/*@editable*/font-style:normal;\n\t\t\t/*@editable*/font-weight:bold;\n\t\t\t/*@editable*/line-height:125%;\n\t\t\t/*@editable*/letter-spacing:normal;\n\t\t\t/*@editable*/text-align:left;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Heading 4\n\t@tip Set the styling for all fourth-level headings in your emails. These should be the smallest of your headings.\n\t@style heading 4\n\t*/\n\t\th4{\n\t\t\t/*@editable*/color:#202020;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:18px;\n\t\t\t/*@editable*/font-style:normal;\n\t\t\t/*@editable*/font-weight:bold;\n\t\t\t/*@editable*/line-height:125%;\n\t\t\t/*@editable*/letter-spacing:normal;\n\t\t\t/*@editable*/text-align:left;\n\t\t}\n\t/*\n\t@tab Preheader\n\t@section Preheader Style\n\t@tip Set the background color and borders for your email's preheader area.\n\t*/\n\t\t#templatePreheader{\n\t\t\t/*@editable*/background-color:#ffffff;\n\t\t\t/*@editable*/background-image:none;\n\t\t\t/*@editable*/background-repeat:no-repeat;\n\t\t\t/*@editable*/background-position:center;\n\t\t\t/*@editable*/background-size:cover;\n\t\t\t/*@editable*/border-top:0;\n\t\t\t/*@editable*/border-bottom:0;\n\t\t\t/*@editable*/padding-top:0px;\n\t\t\t/*@editable*/padding-bottom:0px;\n\t\t}\n\t/*\n\t@tab Preheader\n\t@section Preheader Text\n\t@tip Set the styling for your email's preheader text. Choose a size and color that is easy to read.\n\t*/\n\t\t#templatePreheader .mcnTextContent,#templatePreheader .mcnTextContent p{\n\t\t\t/*@editable*/color:#656565;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:12px;\n\t\t\t/*@editable*/line-height:150%;\n\t\t\t/*@editable*/text-align:center;\n\t\t}\n\t/*\n\t@tab Preheader\n\t@section Preheader Link\n\t@tip Set the styling for your email's preheader links. Choose a color that helps them stand out from your text.\n\t*/\n\t\t#templatePreheader .mcnTextContent a,#templatePreheader .mcnTextContent p a{\n\t\t\t/*@editable*/color:#656565;\n\t\t\t/*@editable*/font-weight:normal;\n\t\t\t/*@editable*/text-decoration:underline;\n\t\t}\n\t/*\n\t@tab Header\n\t@section Header Style\n\t@tip Set the background color and borders for your email's header area.\n\t*/\n\t\t#templateHeader{\n\t\t\t/*@editable*/background-color:#ffffff;\n\t\t\t/*@editable*/background-image:none;\n\t\t\t/*@editable*/background-repeat:no-repeat;\n\t\t\t/*@editable*/background-position:center;\n\t\t\t/*@editable*/background-size:cover;\n\t\t\t/*@editable*/border-top:0;\n\t\t\t/*@editable*/border-bottom:0;\n\t\t\t/*@editable*/padding-top:0px;\n\t\t\t/*@editable*/padding-bottom:0px;\n\t\t}\n\t/*\n\t@tab Header\n\t@section Header Text\n\t@tip Set the styling for your email's header text. Choose a size and color that is easy to read.\n\t*/\n\t\t#templateHeader .mcnTextContent,#templateHeader .mcnTextContent p{\n\t\t\t/*@editable*/color:#202020;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:16px;\n\t\t\t/*@editable*/line-height:150%;\n\t\t\t/*@editable*/text-align:left;\n\t\t}\n\t/*\n\t@tab Header\n\t@section Header Link\n\t@tip Set the styling for your email's header links. Choose a color that helps them stand out from your text.\n\t*/\n\t\t#templateHeader .mcnTextContent a,#templateHeader .mcnTextContent p a{\n\t\t\t/*@editable*/color:#007C89;\n\t\t\t/*@editable*/font-weight:normal;\n\t\t\t/*@editable*/text-decoration:underline;\n\t\t}\n\t/*\n\t@tab Body\n\t@section Body Style\n\t@tip Set the background color and borders for your email's body area.\n\t*/\n\t\t#templateBody{\n\t\t\t/*@editable*/background-color:#ffffff;\n\t\t\t/*@editable*/background-image:url(\"https://mcusercontent.com/7f501c761d1bd8cec028280a2/images/c177e0ce-9867-d418-241f-024ff3891fca.jpg\");\n\t\t\t/*@editable*/background-repeat:no-repeat;\n\t\t\t/*@editable*/background-position:center;\n\t\t\t/*@editable*/background-size:cover;\n\t\t\t/*@editable*/border-top:0;\n\t\t\t/*@editable*/border-bottom:2px solid #EAEAEA;\n\t\t\t/*@editable*/padding-top:0;\n\t\t\t/*@editable*/padding-bottom:9px;\n\t\t}\n\t/*\n\t@tab Body\n\t@section Body Text\n\t@tip Set the styling for your email's body text. Choose a size and color that is easy to read.\n\t*/\n\t\t#templateBody .mcnTextContent,#templateBody .mcnTextContent p{\n\t\t\t/*@editable*/color:#202020;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:16px;\n\t\t\t/*@editable*/line-height:150%;\n\t\t\t/*@editable*/text-align:left;\n\t\t}\n\t/*\n\t@tab Body\n\t@section Body Link\n\t@tip Set the styling for your email's body links. Choose a color that helps them stand out from your text.\n\t*/\n\t\t#templateBody .mcnTextContent a,#templateBody .mcnTextContent p a{\n\t\t\t/*@editable*/color:#007C89;\n\t\t\t/*@editable*/font-weight:normal;\n\t\t\t/*@editable*/text-decoration:underline;\n\t\t}\n\t/*\n\t@tab Footer\n\t@section Footer Style\n\t@tip Set the background color and borders for your email's footer area.\n\t*/\n\t\t#templateFooter{\n\t\t\t/*@editable*/background-color:#ffffff;\n\t\t\t/*@editable*/background-image:none;\n\t\t\t/*@editable*/background-repeat:no-repeat;\n\t\t\t/*@editable*/background-position:center;\n\t\t\t/*@editable*/background-size:cover;\n\t\t\t/*@editable*/border-top:0;\n\t\t\t/*@editable*/border-bottom:0;\n\t\t\t/*@editable*/padding-top:9px;\n\t\t\t/*@editable*/padding-bottom:9px;\n\t\t}\n\t/*\n\t@tab Footer\n\t@section Footer Text\n\t@tip Set the styling for your email's footer text. Choose a size and color that is easy to read.\n\t*/\n\t\t#templateFooter .mcnTextContent,#templateFooter .mcnTextContent p{\n\t\t\t/*@editable*/color:#656565;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:12px;\n\t\t\t/*@editable*/line-height:150%;\n\t\t\t/*@editable*/text-align:center;\n\t\t}\n\t/*\n\t@tab Footer\n\t@section Footer Link\n\t@tip Set the styling for your email's footer links. Choose a color that helps them stand out from your text.\n\t*/\n\t\t#templateFooter .mcnTextContent a,#templateFooter .mcnTextContent p a{\n\t\t\t/*@editable*/color:#656565;\n\t\t\t/*@editable*/font-weight:normal;\n\t\t\t/*@editable*/text-decoration:underline;\n\t\t}\n\t@media only screen and (min-width:768px){\n\t\t.templateContainer{\n\t\t\twidth:600px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\tbody,table,td,p,a,li,blockquote{\n\t\t\t-webkit-text-size-adjust:none !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\tbody{\n\t\t\twidth:100% !important;\n\t\t\tmin-width:100% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnRetinaImage{\n\t\t\tmax-width:100% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImage{\n\t\t\twidth:100% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnCartContainer,.mcnCaptionTopContent,.mcnRecContentContainer,.mcnCaptionBottomContent,.mcnTextContentContainer,.mcnBoxedTextContentContainer,.mcnImageGroupContentContainer,.mcnCaptionLeftTextContentContainer,.mcnCaptionRightTextContentContainer,.mcnCaptionLeftImageContentContainer,.mcnCaptionRightImageContentContainer,.mcnImageCardLeftTextContentContainer,.mcnImageCardRightTextContentContainer,.mcnImageCardLeftImageContentContainer,.mcnImageCardRightImageContentContainer{\n\t\t\tmax-width:100% !important;\n\t\t\twidth:100% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnBoxedTextContentContainer{\n\t\t\tmin-width:100% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImageGroupContent{\n\t\t\tpadding:9px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnCaptionLeftContentOuter .mcnTextContent,.mcnCaptionRightContentOuter .mcnTextContent{\n\t\t\tpadding-top:9px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImageCardTopImageContent,.mcnCaptionBottomContent:last-child .mcnCaptionBottomImageContent,.mcnCaptionBlockInner .mcnCaptionTopContent:last-child .mcnTextContent{\n\t\t\tpadding-top:18px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImageCardBottomImageContent{\n\t\t\tpadding-bottom:9px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImageGroupBlockInner{\n\t\t\tpadding-top:0 !important;\n\t\t\tpadding-bottom:0 !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImageGroupBlockOuter{\n\t\t\tpadding-top:9px !important;\n\t\t\tpadding-bottom:9px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnTextContent,.mcnBoxedTextContentColumn{\n\t\t\tpadding-right:18px !important;\n\t\t\tpadding-left:18px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImageCardLeftImageContent,.mcnImageCardRightImageContent{\n\t\t\tpadding-right:18px !important;\n\t\t\tpadding-bottom:0 !important;\n\t\t\tpadding-left:18px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcpreview-image-uploader{\n\t\t\tdisplay:none !important;\n\t\t\twidth:100% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Heading 1\n\t@tip Make the first-level headings larger in size for better readability on small screens.\n\t*/\n\t\th1{\n\t\t\t/*@editable*/font-size:22px !important;\n\t\t\t/*@editable*/line-height:125% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Heading 2\n\t@tip Make the second-level headings larger in size for better readability on small screens.\n\t*/\n\t\th2{\n\t\t\t/*@editable*/font-size:20px !important;\n\t\t\t/*@editable*/line-height:125% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Heading 3\n\t@tip Make the third-level headings larger in size for better readability on small screens.\n\t*/\n\t\th3{\n\t\t\t/*@editable*/font-size:18px !important;\n\t\t\t/*@editable*/line-height:125% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Heading 4\n\t@tip Make the fourth-level headings larger in size for better readability on small screens.\n\t*/\n\t\th4{\n\t\t\t/*@editable*/font-size:16px !important;\n\t\t\t/*@editable*/line-height:150% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Boxed Text\n\t@tip Make the boxed text larger in size for better readability on small screens. We recommend a font size of at least 16px.\n\t*/\n\t\t.mcnBoxedTextContentContainer .mcnTextContent,.mcnBoxedTextContentContainer .mcnTextContent p{\n\t\t\t/*@editable*/font-size:14px !important;\n\t\t\t/*@editable*/line-height:150% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Preheader Visibility\n\t@tip Set the visibility of the email's preheader on small screens. You can hide it to save space.\n\t*/\n\t\t#templatePreheader{\n\t\t\t/*@editable*/display:block !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Preheader Text\n\t@tip Make the preheader text larger in size for better readability on small screens.\n\t*/\n\t\t#templatePreheader .mcnTextContent,#templatePreheader .mcnTextContent p{\n\t\t\t/*@editable*/font-size:14px !important;\n\t\t\t/*@editable*/line-height:150% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Header Text\n\t@tip Make the header text larger in size for better readability on small screens.\n\t*/\n\t\t#templateHeader .mcnTextContent,#templateHeader .mcnTextContent p{\n\t\t\t/*@editable*/font-size:16px !important;\n\t\t\t/*@editable*/line-height:150% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Body Text\n\t@tip Make the body text larger in size for better readability on small screens. We recommend a font size of at least 16px.\n\t*/\n\t\t#templateBody .mcnTextContent,#templateBody .mcnTextContent p{\n\t\t\t/*@editable*/font-size:16px !important;\n\t\t\t/*@editable*/line-height:150% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Footer Text\n\t@tip Make the footer content text larger in size for better readability on small screens.\n\t*/\n\t\t#templateFooter .mcnTextContent,#templateFooter .mcnTextContent p{\n\t\t\t/*@editable*/font-size:14px !important;\n\t\t\t/*@editable*/line-height:150% !important;\n\t\t}\n\n}",
        }}
      />

      {/**|IF:MC_PREVIEW_TEXT|**/}
      {/*[if !gte mso 9]><!--*/}
      <span
        className="mcnPreviewText"
        style={{
          display: "none",
          fontSize: 0,
          lineHeight: 0,
          maxHeight: 0,
          maxWidth: 0,
          opacity: 0,
          overflow: "hidden",
          visibility: "hidden",
          msoHide: "all",
        }}
      >
        *|MC_PREVIEW_TEXT|*
      </span>
      {/*<![endif]*/}
      {/**|END:IF|**/}
      <center>
        <table
          align="center"
          border={0}
          cellPadding={0}
          cellSpacing={0}
          height="100%"
          width="100%"
          id="bodyTable"
        >
          <tbody>
            <tr>
              <td align="center" valign="top" id="bodyCell">
                {/* BEGIN TEMPLATE // */}
                {/*[if (gte mso 9)|(IE)]>
                  <table align="center" border="0" cellspacing="0" cellpadding="0" width="600" style="width:600px;">
                  <tr>
                  <td align="center" valign="top" width="600" style="width:600px;">
                  <![endif]*/}
                <table
                  border={0}
                  cellPadding={0}
                  cellSpacing={0}
                  width="100%"
                  className="templateContainer"
                >
                  <tbody>
                    <tr>
                      <td valign="top" id="templatePreheader" />
                    </tr>
                    <tr>
                      <td valign="top" id="templateHeader">
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnImageBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnImageBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                style={{ padding: 9 }}
                                className="mcnImageBlockInner"
                              >
                                <table
                                  align="left"
                                  width="100%"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="mcnImageContentContainer"
                                  style={{ minWidth: "100%" }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        className="mcnImageContent"
                                        valign="top"
                                        style={{
                                          paddingRight: 9,
                                          paddingLeft: 9,
                                          paddingTop: 0,
                                          paddingBottom: 0,
                                          textAlign: "center",
                                        }}
                                      >
                                        <img
                                          align="center"
                                          alt=""
                                          src="https://mcusercontent.com/7f501c761d1bd8cec028280a2/images/c60f3dfc-04d0-a231-4956-80e54faeeac0.png"
                                          width="270.71999999999997"
                                          style={{
                                            maxWidth: 4266,
                                            paddingBottom: 0,
                                            display: "inline !important",
                                            verticalAlign: "bottom",
                                          }}
                                          className="mcnImage"
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnCodeBlock"
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td valign="top" className="mcnTextBlockInner">
                                <div
                                  className="mcnTextContent"
                                  style={{
                                    display: "flex!important",
                                    justifyContent: "flex-end!important",
                                  }}
                                >
                                  <h2
                                    style={{
                                      width: "150px!important",
                                      padding: 5,
                                      pointerEvent: "none!important",
                                      textAlign: "center!important",
                                      textDecoration: "unset!important",
                                      maxWidth: "150px!important",
                                      display: "flex!important",
                                      justifyContent: "center!important",
                                      fontFamily: '"helvetica"!important',
                                      fontSize: "18px!important",
                                      color: "#21759c!important",
                                      borderRadius: "5px 5px 0 0!important",
                                      border: "2px solid #21759c",
                                    }}
                                  >
                                    Juillet 2025
                                  </h2>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td valign="top" id="templateBody">
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnCodeBlock"
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td valign="top" className="mcnTextBlockInner">
                                <div className="mcnTextContent">
                                  <h2
                                    style={{
                                      textAling: "left",
                                      fontFamily: '"helvetica"',
                                      textTransform: "uppercase",
                                      color: "white",
                                      backgroundColor: "#21759c",
                                      padding: "7px 7px 7px 15px",
                                      boxShadow: "0 2px 10px -5px black",
                                    }}
                                  >
                                    E-CAMPUS 2025-2026
                                  </h2>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnTextBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                className="mcnTextBlockInner"
                                style={{ paddingTop: 9 }}
                              >
                                {/*[if mso]>
        <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
        <tr>
        <![endif]*/}
                                {/*[if mso]>
        <td valign="top" width="600" style="width:600px;">
        <![endif]*/}
                                <table
                                  align="left"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ maxWidth: "100%", minWidth: "100%" }}
                                  width="100%"
                                  className="mcnTextContentContainer"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        className="mcnTextContent"
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: 18,
                                          paddingBottom: 9,
                                          paddingLeft: 18,
                                        }}
                                      >
                                        <div style={{ textAlign: "justify" }}>
                                          <p style={{ textAlign: "justify" }}>
                                            <strong>
                                              Chères enseignantes, chers
                                              enseignants,
                                            </strong>
                                            <br />
                                            &nbsp;
                                          </p>
                                          <p style={{ textAlign: "center" }}>
                                            <span style={{ color: "#e84e24" }}>
                                              <strong>
                                                La plateforme de cours en ligne,
                                                e-campus 2025-2026, est
                                                disponible depuis le 2 Juillet
                                                2025.
                                              </strong>
                                            </span>
                                          </p>
                                          <p style={{ textAlign: "justify" }}>
                                            <br />
                                            Vous pouvez dès à présent récupérer
                                            vos cours de l’année passée, créer
                                            votre nouvel espace d’enseignement
                                            ou encore explorer les outils
                                            pédagogiques et numériques mis à
                                            votre disposition.
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]>
        </td>
        <![endif]*/}
                                {/*[if mso]>
        </tr>
        </table>
        <![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnImageBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnImageBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                style={{ padding: 9 }}
                                className="mcnImageBlockInner"
                              >
                                <table
                                  align="left"
                                  width="100%"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="mcnImageContentContainer"
                                  style={{ minWidth: "100%" }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        className="mcnImageContent"
                                        valign="top"
                                        style={{
                                          paddingRight: 9,
                                          paddingLeft: 9,
                                          paddingTop: 0,
                                          paddingBottom: 0,
                                          textAlign: "center",
                                        }}
                                      >
                                        <img
                                          align="center"
                                          alt=""
                                          src="https://mcusercontent.com/7f501c761d1bd8cec028280a2/images/d15e4537-e851-10bb-f94e-4696feeb8bff.png"
                                          width={564}
                                          style={{
                                            maxWidth: 4336,
                                            paddingBottom: 0,
                                            display: "inline !important",
                                            verticalAlign: "bottom",
                                          }}
                                          className="mcnImage"
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnTextBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                className="mcnTextBlockInner"
                                style={{ paddingTop: 9 }}
                              >
                                {/*[if mso]>
        <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
        <tr>
        <![endif]*/}
                                {/*[if mso]>
        <td valign="top" width="600" style="width:600px;">
        <![endif]*/}
                                <table
                                  align="left"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ maxWidth: "100%", minWidth: "100%" }}
                                  width="100%"
                                  className="mcnTextContentContainer"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        className="mcnTextContent"
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: 18,
                                          paddingBottom: 9,
                                          paddingLeft: 18,
                                        }}
                                      >
                                        <div style={{ textAlign: "justify" }}>
                                          <p>
                                            e-campus évolue grâce à vos retours
                                            tout au long de l’année ! La
                                            plateforme propose désormais{" "}
                                            <strong>une page unique</strong> qui
                                            réunit, en un seul coup d'œil, les
                                            informations essentielles et
                                            l’ensemble de votre tableau de bord.
                                            <br />
                                            &nbsp;
                                          </p>
                                          <p style={{ textAlign: "center" }}>
                                            Toutes les informations utiles sont
                                            maintenant centralisées dans un seul
                                            espace : votre{" "}
                                            <strong>
                                              <em>Tableau de bord</em>{" "}
                                            </strong>
                                            !<br />
                                            &nbsp;
                                          </p>
                                          <p>
                                            Autre nouveauté : la{" "}
                                            <em>
                                              <strong>
                                                Foire aux questions
                                              </strong>
                                            </em>{" "}
                                            est directement accessible depuis le
                                            menu général, en haut de l’écran.
                                            Elle propose désormais deux versions
                                            distinctes : une dédiée aux
                                            étudiant·e·s et une autre aux
                                            enseignant·e·s, afin de mieux
                                            répondre à vos besoins.&nbsp;
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]>
        </td>
        <![endif]*/}
                                {/*[if mso]>
        </tr>
        </table>
        <![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnImageBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnImageBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                style={{ padding: 0 }}
                                className="mcnImageBlockInner"
                              >
                                <table
                                  align="left"
                                  width="100%"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="mcnImageContentContainer"
                                  style={{ minWidth: "100%" }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        className="mcnImageContent"
                                        valign="top"
                                        style={{
                                          paddingRight: 0,
                                          paddingLeft: 0,
                                          paddingTop: 0,
                                          paddingBottom: 0,
                                          textAlign: "center",
                                        }}
                                      >
                                        <img
                                          align="center"
                                          alt=""
                                          src="https://mcusercontent.com/7f501c761d1bd8cec028280a2/images/0517567c-ba04-3489-5f07-52ac832d4ba0.png"
                                          width={600}
                                          style={{
                                            maxWidth: 1467,
                                            paddingBottom: 0,
                                            display: "inline !important",
                                            verticalAlign: "bottom",
                                          }}
                                          className="mcnImage"
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnButtonBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnButtonBlockOuter">
                            <tr>
                              <td
                                style={{
                                  paddingTop: 0,
                                  paddingRight: 18,
                                  paddingBottom: 18,
                                  paddingLeft: 18,
                                }}
                                valign="top"
                                align="center"
                                className="mcnButtonBlockInner"
                              >
                                <table
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="mcnButtonContentContainer"
                                  style={{
                                    borderCollapse: "separate !important",
                                    borderRadius: 4,
                                    backgroundColor: "#E84E24",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        align="center"
                                        valign="middle"
                                        className="mcnButtonContent"
                                        style={{
                                          fontFamily: "Arial",
                                          fontSize: 16,
                                          padding: 18,
                                        }}
                                      >
                                        <a
                                          className="mcnButton "
                                          title="ecampus 2025-2026"
                                          href="https://ecampus.unimes.fr"
                                          target="_blank"
                                          style={{
                                            fontWeight: "bold",
                                            letterSpacing: "normal",
                                            lineHeight: "100%",
                                            textAlign: "center",
                                            textDecoration: "none",
                                            color: "#FFFFFF",
                                          }}
                                        >
                                          ecampus 2025-2026
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnTextBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                className="mcnTextBlockInner"
                                style={{ paddingTop: 9 }}
                              >
                                {/*[if mso]>
        <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
        <tr>
        <![endif]*/}
                                {/*[if mso]>
        <td valign="top" width="600" style="width:600px;">
        <![endif]*/}
                                <table
                                  align="left"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ maxWidth: "100%", minWidth: "100%" }}
                                  width="100%"
                                  className="mcnTextContentContainer"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        className="mcnTextContent"
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: 18,
                                          paddingBottom: 9,
                                          paddingLeft: 18,
                                        }}
                                      >
                                        <div style={{ textAlign: "justify" }}>
                                          <p style={{ textAlign: "justify" }}>
                                            Ne perdez pas de temps ! Pour
                                            restaurer un cours, suivez dès à
                                            présent la procédure expliquée dans
                                            la Foire aux questions e-campus :
                                            rubrique{" "}
                                            <em>
                                              <strong>
                                                Créer et gérer mon espace de
                                                cours,
                                              </strong>
                                            </em>{" "}
                                            section{" "}
                                            <em>
                                              <strong>
                                                Comment restaurer un cours sur
                                                e-campus ?
                                              </strong>
                                            </em>{" "}
                                            Cela vous évitera le stress de la
                                            rentrée.
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]>
        </td>
        <![endif]*/}
                                {/*[if mso]>
        </tr>
        </table>
        <![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnButtonBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnButtonBlockOuter">
                            <tr>
                              <td
                                style={{
                                  paddingTop: 0,
                                  paddingRight: 18,
                                  paddingBottom: 18,
                                  paddingLeft: 18,
                                }}
                                valign="top"
                                align="center"
                                className="mcnButtonBlockInner"
                              >
                                <table
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="mcnButtonContentContainer"
                                  style={{
                                    borderCollapse: "separate !important",
                                    borderRadius: 4,
                                    backgroundColor: "#E84E24",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        align="center"
                                        valign="middle"
                                        className="mcnButtonContent"
                                        style={{
                                          fontFamily: "Arial",
                                          fontSize: 16,
                                          padding: 18,
                                        }}
                                      >
                                        <a
                                          className="mcnButton "
                                          title="Accéder à la FAQ"
                                          href="https://ecampus.unimes.fr/course/view.php?id=5518"
                                          target="_blank"
                                          style={{
                                            fontWeight: "bold",
                                            letterSpacing: "normal",
                                            lineHeight: "100%",
                                            textAlign: "center",
                                            textDecoration: "none",
                                            color: "#FFFFFF",
                                          }}
                                        >
                                          Accéder à la FAQ
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnTextBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                className="mcnTextBlockInner"
                                style={{ paddingTop: 9 }}
                              >
                                {/*[if mso]>
        <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
        <tr>
        <![endif]*/}
                                {/*[if mso]>
        <td valign="top" width="600" style="width:600px;">
        <![endif]*/}
                                <table
                                  align="left"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ maxWidth: "100%", minWidth: "100%" }}
                                  width="100%"
                                  className="mcnTextContentContainer"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        className="mcnTextContent"
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: 18,
                                          paddingBottom: 9,
                                          paddingLeft: 18,
                                        }}
                                      >
                                        <div style={{ textAlign: "justify" }}>
                                          <p style={{ textAlign: "justify" }}>
                                            Le SNAP est disponible et à votre
                                            disposition en cette fin d'année
                                            pour vous aider.
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]>
        </td>
        <![endif]*/}
                                {/*[if mso]>
        </tr>
        </table>
        <![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnButtonBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnButtonBlockOuter">
                            <tr>
                              <td
                                style={{
                                  paddingTop: 0,
                                  paddingRight: 18,
                                  paddingBottom: 18,
                                  paddingLeft: 18,
                                }}
                                valign="top"
                                align="center"
                                className="mcnButtonBlockInner"
                              >
                                <table
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="mcnButtonContentContainer"
                                  style={{
                                    borderCollapse: "separate !important",
                                    borderRadius: 4,
                                    backgroundColor: "#E84E24",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        align="center"
                                        valign="middle"
                                        className="mcnButtonContent"
                                        style={{
                                          fontFamily: "Arial",
                                          fontSize: 16,
                                          padding: 18,
                                        }}
                                      >
                                        <a
                                          className="mcnButton "
                                          title="formulaire de création / récupération de cours"
                                          href="https://ecampus.unimes.fr/local/creation_cours/creation_cours.php"
                                          target="_blank"
                                          style={{
                                            fontWeight: "bold",
                                            letterSpacing: "normal",
                                            lineHeight: "100%",
                                            textAlign: "center",
                                            textDecoration: "none",
                                            color: "#FFFFFF",
                                          }}
                                        >
                                          formulaire de création / récupération
                                          de cours
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnTextBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                className="mcnTextBlockInner"
                                style={{ paddingTop: 9 }}
                              >
                                {/*[if mso]>
        <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
        <tr>
        <![endif]*/}
                                {/*[if mso]>
        <td valign="top" width="600" style="width:600px;">
        <![endif]*/}
                                <table
                                  align="left"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ maxWidth: "100%", minWidth: "100%" }}
                                  width="100%"
                                  className="mcnTextContentContainer"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        className="mcnTextContent"
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: 18,
                                          paddingBottom: 9,
                                          paddingLeft: 18,
                                        }}
                                      >
                                        <div style={{ textAlign: "justify" }}>
                                          <p style={{ textAlign: "justify" }}>
                                            Comme les années précédentes, les
                                            dépôts de devoirs qui auraient lieu
                                            durant l'été doivent être faits sur
                                            l'ancienne plateforme, désormais
                                            disponible à l'adresse{" "}
                                            <a
                                              href="https://ecampus2024.unimes.fr/"
                                              target="_blank"
                                            >
                                              <strong>
                                                <u>ecampus2024.unimes.fr</u>
                                              </strong>
                                            </a>
                                            .<br />
                                            &nbsp;
                                          </p>
                                          <p style={{ textAlign: "center" }}>
                                            <span style={{ fontSize: 18 }}>
                                              <span
                                                style={{ color: "#e84e24" }}
                                              >
                                                <strong>
                                                  Il appartient aux enseignants
                                                  de rendre visible les cours
                                                  concernés, toutefois, le SNAP
                                                  reste à votre disposition pour
                                                  vous accompagner.
                                                </strong>
                                              </span>
                                            </span>
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]>
        </td>
        <![endif]*/}
                                {/*[if mso]>
        </tr>
        </table>
        <![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnDividerBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnDividerBlockOuter">
                            <tr>
                              <td
                                className="mcnDividerBlockInner"
                                style={{ minWidth: "100%", padding: 18 }}
                              >
                                <table
                                  className="mcnDividerContent"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  width="100%"
                                  style={{
                                    minWidth: "100%",
                                    borderTop: "2px solid #EAEAEA",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td>
                                        <span />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*            
          <td class="mcnDividerBlockInner" style="padding: 18px;">
          <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnCodeBlock"
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td valign="top" className="mcnTextBlockInner">
                                <div className="mcnTextContent">
                                  <h2
                                    style={{
                                      textAling: "left",
                                      fontFamily: '"helvetica"',
                                      textTransform: "uppercase",
                                      color: "white",
                                      backgroundColor: "#21759c",
                                      padding: "7px 7px 7px 15px",
                                      boxShadow: "0 2px 10px -5px black",
                                    }}
                                  >
                                    On vous rappellera
                                  </h2>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnTextBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                className="mcnTextBlockInner"
                                style={{ paddingTop: 9 }}
                              >
                                {/*[if mso]>
        <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
        <tr>
        <![endif]*/}
                                {/*[if mso]>
        <td valign="top" width="600" style="width:600px;">
        <![endif]*/}
                                <table
                                  align="left"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ maxWidth: "100%", minWidth: "100%" }}
                                  width="100%"
                                  className="mcnTextContentContainer"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        className="mcnTextContent"
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: 18,
                                          paddingBottom: 9,
                                          paddingLeft: 18,
                                        }}
                                      >
                                        <div style={{ textAlign: "justify" }}>
                                          <p style={{ textAlign: "justify" }}>
                                            Nous lançons la version bêta du{" "}
                                            <strong>
                                              tout premier jeu vidéo Nîmes
                                              Université
                                            </strong>{" "}
                                            après 2 ans de développement : « On
                                            vous rappellera », un jeu pour aider
                                            les étudiant·e·s à se préparer à
                                            l’entretien d’embauche.
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]>
        </td>
        <![endif]*/}
                                {/*[if mso]>
        </tr>
        </table>
        <![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnImageBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnImageBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                style={{ padding: 9 }}
                                className="mcnImageBlockInner"
                              >
                                <table
                                  align="left"
                                  width="100%"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="mcnImageContentContainer"
                                  style={{ minWidth: "100%" }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        className="mcnImageContent"
                                        valign="top"
                                        style={{
                                          paddingRight: 9,
                                          paddingLeft: 9,
                                          paddingTop: 0,
                                          paddingBottom: 0,
                                          textAlign: "center",
                                        }}
                                      >
                                        <img
                                          align="center"
                                          alt=""
                                          src="https://mcusercontent.com/7f501c761d1bd8cec028280a2/images/63bbb4df-cb81-238d-5bf5-cb39c592c098.jpg"
                                          width={564}
                                          style={{
                                            maxWidth: 1080,
                                            paddingBottom: 0,
                                            display: "inline !important",
                                            verticalAlign: "bottom",
                                          }}
                                          className="mcnImage"
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnTextBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                className="mcnTextBlockInner"
                                style={{ paddingTop: 9 }}
                              >
                                {/*[if mso]>
        <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
        <tr>
        <![endif]*/}
                                {/*[if mso]>
        <td valign="top" width="600" style="width:600px;">
        <![endif]*/}
                                <table
                                  align="left"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ maxWidth: "100%", minWidth: "100%" }}
                                  width="100%"
                                  className="mcnTextContentContainer"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        className="mcnTextContent"
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: 18,
                                          paddingBottom: 9,
                                          paddingLeft: 18,
                                        }}
                                      >
                                        <div style={{ textAlign: "justify" }}>
                                          <p>
                                            Cette bêta est une version quasi
                                            finalisée, encore en phase de test.
                                            Nous comptons sur vous pour la
                                            tester, repérer d’éventuels bugs et
                                            nous faire part de vos impressions
                                            afin d’améliorer le jeu avant sa
                                            sortie officielle prévue pour la
                                            rentrée 2025-2026.
                                          </p>
                                          <p>
                                            Le jeu sera disponible sur iOS,
                                            Android et PC.
                                          </p>
                                          <p>
                                            📲 Pour participer et accéder à
                                            cette version de test,
                                            inscrivez-vous dès maintenant :
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]>
        </td>
        <![endif]*/}
                                {/*[if mso]>
        </tr>
        </table>
        <![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnButtonBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnButtonBlockOuter">
                            <tr>
                              <td
                                style={{
                                  paddingTop: 0,
                                  paddingRight: 18,
                                  paddingBottom: 18,
                                  paddingLeft: 18,
                                }}
                                valign="top"
                                align="center"
                                className="mcnButtonBlockInner"
                              >
                                <table
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="mcnButtonContentContainer"
                                  style={{
                                    borderCollapse: "separate !important",
                                    borderRadius: 4,
                                    backgroundColor: "#E84E24",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        align="center"
                                        valign="middle"
                                        className="mcnButtonContent"
                                        style={{
                                          fontFamily: "Arial",
                                          fontSize: 16,
                                          padding: 18,
                                        }}
                                      >
                                        <a
                                          className="mcnButton "
                                          title='Je m&apos;inscris pour tester "On vous rappellera"'
                                          href="https://forms.office.com/e/eA5xAY8Vwk"
                                          target="_blank"
                                          style={{
                                            fontWeight: "bold",
                                            letterSpacing: "normal",
                                            lineHeight: "100%",
                                            textAlign: "center",
                                            textDecoration: "none",
                                            color: "#FFFFFF",
                                          }}
                                        >
                                          Je m'inscris pour tester "On vous
                                          rappellera"
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnTextBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                className="mcnTextBlockInner"
                                style={{ paddingTop: 9 }}
                              >
                                {/*[if mso]>
        <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
        <tr>
        <![endif]*/}
                                {/*[if mso]>
        <td valign="top" width="600" style="width:600px;">
        <![endif]*/}
                                <table
                                  align="left"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ maxWidth: "100%", minWidth: "100%" }}
                                  width="100%"
                                  className="mcnTextContentContainer"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        className="mcnTextContent"
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: 18,
                                          paddingBottom: 9,
                                          paddingLeft: 18,
                                        }}
                                      >
                                        <div style={{ textAlign: "justify" }}>
                                          <p style={{ textAlign: "justify" }}>
                                            <strong>
                                              Merci d’avance à toutes celles et
                                              ceux qui prendront part à cette
                                              phase de test. Votre retour est
                                              précieux pour finaliser le jeu !
                                            </strong>
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]>
        </td>
        <![endif]*/}
                                {/*[if mso]>
        </tr>
        </table>
        <![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnDividerBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnDividerBlockOuter">
                            <tr>
                              <td
                                className="mcnDividerBlockInner"
                                style={{ minWidth: "100%", padding: 18 }}
                              >
                                <table
                                  className="mcnDividerContent"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  width="100%"
                                  style={{
                                    minWidth: "100%",
                                    borderTop: "2px solid #EAEAEA",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td>
                                        <span />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*            
          <td class="mcnDividerBlockInner" style="padding: 18px;">
          <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnCodeBlock"
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td valign="top" className="mcnTextBlockInner">
                                <div className="mcnTextContent">
                                  <h2
                                    style={{
                                      textAling: "left",
                                      fontFamily: '"helvetica"',
                                      textTransform: "uppercase",
                                      color: "white",
                                      backgroundColor: "#21759c",
                                      padding: "7px 7px 7px 15px",
                                      boxShadow: "0 2px 10px -5px black",
                                    }}
                                  >
                                    Showroom technologies numériques
                                  </h2>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnImageBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnImageBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                style={{ padding: 0 }}
                                className="mcnImageBlockInner"
                              >
                                <table
                                  align="left"
                                  width="100%"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="mcnImageContentContainer"
                                  style={{ minWidth: "100%" }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        className="mcnImageContent"
                                        valign="top"
                                        style={{
                                          paddingRight: 0,
                                          paddingLeft: 0,
                                          paddingTop: 0,
                                          paddingBottom: 0,
                                          textAlign: "center",
                                        }}
                                      >
                                        <img
                                          align="center"
                                          alt=""
                                          src="https://mcusercontent.com/7f501c761d1bd8cec028280a2/images/a18e09f7-ddd5-c318-545a-55e95af46d6c.jpg"
                                          width={600}
                                          style={{
                                            maxWidth: 2044,
                                            paddingBottom: 0,
                                            verticalAlign: "bottom",
                                            display: "inline !important",
                                            borderRadius: "0%",
                                          }}
                                          className="mcnImage"
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnTextBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                className="mcnTextBlockInner"
                                style={{ paddingTop: 9 }}
                              >
                                {/*[if mso]>
        <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
        <tr>
        <![endif]*/}
                                {/*[if mso]>
        <td valign="top" width="600" style="width:600px;">
        <![endif]*/}
                                <table
                                  align="left"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ maxWidth: "100%", minWidth: "100%" }}
                                  width="100%"
                                  className="mcnTextContentContainer"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        className="mcnTextContent"
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: 18,
                                          paddingBottom: 9,
                                          paddingLeft: 18,
                                        }}
                                      >
                                        <div style={{ textAlign: "center" }}>
                                          <strong>
                                            Vous avez été nombreux à venir
                                            découvrir les technologies et outils
                                            numériques pour l’enseignement lors
                                            de notre événement du 15 mai au 10
                                            juin 2025, et nous vous remercions
                                            vivement pour votre participation !
                                          </strong>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]>
        </td>
        <![endif]*/}
                                {/*[if mso]>
        </tr>
        </table>
        <![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnImageBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnImageBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                style={{ padding: 0 }}
                                className="mcnImageBlockInner"
                              >
                                <table
                                  align="left"
                                  width="100%"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  className="mcnImageContentContainer"
                                  style={{ minWidth: "100%" }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        className="mcnImageContent"
                                        valign="top"
                                        style={{
                                          paddingRight: 0,
                                          paddingLeft: 0,
                                          paddingTop: 0,
                                          paddingBottom: 0,
                                          textAlign: "center",
                                        }}
                                      >
                                        <img
                                          align="center"
                                          alt=""
                                          src="https://mcusercontent.com/7f501c761d1bd8cec028280a2/images/89a44a45-867e-2cf9-0def-60c73c5b5aba.png"
                                          width={600}
                                          style={{
                                            maxWidth: 1920,
                                            paddingBottom: 0,
                                            verticalAlign: "bottom",
                                            display: "inline !important",
                                            borderRadius: "0%",
                                          }}
                                          className="mcnImage"
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnTextBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                className="mcnTextBlockInner"
                                style={{ paddingTop: 9 }}
                              >
                                {/*[if mso]>
        <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
        <tr>
        <![endif]*/}
                                {/*[if mso]>
        <td valign="top" width="600" style="width:600px;">
        <![endif]*/}
                                <table
                                  align="left"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ maxWidth: "100%", minWidth: "100%" }}
                                  width="100%"
                                  className="mcnTextContentContainer"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        className="mcnTextContent"
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: 18,
                                          paddingBottom: 9,
                                          paddingLeft: 18,
                                        }}
                                      >
                                        <div style={{ textAlign: "justify" }}>
                                          <p>
                                            Vos retours ont été précieux, et
                                            nous étudions actuellement la mise
                                            en place des équipements les plus
                                            sollicités, parmi lesquels :
                                          </p>
                                          <ul>
                                            <li>
                                              &nbsp;&nbsp;&nbsp;
                                              <em>
                                                <strong>
                                                  {" "}
                                                  L’écran transparent
                                                </strong>
                                              </em>{" "}
                                              permettant d’écrire face aux
                                              étudiant·e·s,
                                            </li>
                                            <li>
                                              &nbsp;&nbsp;&nbsp; Le{" "}
                                              <em>
                                                <strong>
                                                  système de partage d’écrans
                                                </strong>
                                              </em>
                                              , pour encourager la connectivité
                                              et la collaboration,
                                            </li>
                                            <li>
                                              &nbsp;&nbsp;&nbsp; Les{" "}
                                              <em>
                                                <strong>
                                                  tableaux coulissants{" "}
                                                </strong>
                                              </em>
                                              sur moniteur tactile intégré,
                                            </li>
                                            <li>
                                              &nbsp;&nbsp;&nbsp; Et bien sûr, le{" "}
                                              <em>
                                                <strong>
                                                  CatchBox, ce micro cubique à
                                                  lancer
                                                </strong>
                                              </em>{" "}
                                              pour favoriser la prise de parole
                                              en cours.
                                            </li>
                                          </ul>
                                          <p>
                                            Si vous souhaitez réfléchir à
                                            l’intégration de ce type de matériel
                                            dans vos espaces, ou si vous avez
                                            des projets &nbsp;d’aménagement
                                            pédagogique, n’hésitez pas à nous
                                            solliciter. Nous sommes à votre
                                            disposition pour vous accompagner et
                                            étudier ensemble les solutions les
                                            plus adaptées à vos besoins.
                                          </p>
                                          <p>
                                            Nous vous souhaitons un très bel été
                                            et espérons vous retrouver nombreux
                                            lors de nos prochaines initiatives.
                                          </p>
                                          <div style={{ textAlign: "right" }}>
                                            L’équipe SNAP
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]>
        </td>
        <![endif]*/}
                                {/*[if mso]>
        </tr>
        </table>
        <![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnDividerBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnDividerBlockOuter">
                            <tr>
                              <td
                                className="mcnDividerBlockInner"
                                style={{ minWidth: "100%", padding: 18 }}
                              >
                                <table
                                  className="mcnDividerContent"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  width="100%"
                                  style={{
                                    minWidth: "100%",
                                    borderTop: "2px solid #EAEAEA",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td>
                                        <span />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*            
          <td class="mcnDividerBlockInner" style="padding: 18px;">
          <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td valign="top" id="templateFooter">
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnTextBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnTextBlockOuter">
                            <tr>
                              <td
                                valign="top"
                                className="mcnTextBlockInner"
                                style={{ paddingTop: 9 }}
                              >
                                {/*[if mso]>
        <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
        <tr>
        <![endif]*/}
                                {/*[if mso]>
        <td valign="top" width="600" style="width:600px;">
        <![endif]*/}
                                <table
                                  align="left"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ maxWidth: "100%", minWidth: "100%" }}
                                  width="100%"
                                  className="mcnTextContentContainer"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        valign="top"
                                        className="mcnTextContent"
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: 18,
                                          paddingBottom: 9,
                                          paddingLeft: 18,
                                        }}
                                      >
                                        <div style={{ textAlign: "justify" }}>
                                          <h4 style={{ textAlign: "center" }}>
                                            <span style={{ fontSize: 18 }}>
                                              Service Numérique &amp;
                                              Accompagnement Pédagogique (SNAP)
                                            </span>
                                          </h4>
                                          <p style={{ textAlign: "center" }}>
                                            <span style={{ fontSize: 18 }}>
                                              Nîmes Université- Site Vauban -
                                              Bat D, bureaux&nbsp;D121
                                              et&nbsp;D119 - Rue du Dr Georges
                                              Salan - CS13019 30021 Nîmes Cedex
                                              01
                                            </span>
                                          </p>
                                          <p style={{ textAlign: "center" }}>
                                            <span style={{ fontSize: 18 }}>
                                              &nbsp;04 66 36 46 28
                                            </span>
                                          </p>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*[if mso]>
        </td>
        <![endif]*/}
                                {/*[if mso]>
        </tr>
        </table>
        <![endif]*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnFollowBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnFollowBlockOuter">
                            <tr>
                              <td
                                align="center"
                                valign="top"
                                style={{ padding: 9 }}
                                className="mcnFollowBlockInner"
                              >
                                <table
                                  width="100%"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  style={{ minWidth: "100%" }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        align="center"
                                        style={{
                                          paddingLeft: 9,
                                          paddingRight: 9,
                                        }}
                                      >
                                        <table
                                          border={0}
                                          cellPadding={0}
                                          cellSpacing={0}
                                          width="100%"
                                          style={{ minWidth: "100%" }}
                                          className="mcnFollowContentContainer"
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="center"
                                                valign="top"
                                                style={{ padding: 10 }}
                                                className="mcnFollowContent"
                                              >
                                                <table
                                                  border={0}
                                                  cellPadding={0}
                                                  cellSpacing={0}
                                                >
                                                  <tbody>
                                                    <tr>
                                                      <td
                                                        align="left"
                                                        valign="top"
                                                      >
                                                        <table
                                                          border={0}
                                                          cellPadding={0}
                                                          cellSpacing={0}
                                                          width="100%"
                                                          className="mcnFollowContentItem"
                                                        >
                                                          <tbody>
                                                            <tr>
                                                              <td
                                                                align="left"
                                                                valign="top"
                                                                width={24}
                                                                style={{
                                                                  paddingRight: 5,
                                                                  paddingLeft: 0,
                                                                  paddingBottom: 10,
                                                                }}
                                                                className="mcnFollowIconContent"
                                                              >
                                                                <a
                                                                  href="mailto:snap@unimes.fr"
                                                                  target="_blank"
                                                                >
                                                                  <img
                                                                    src="https://cdn-images.mailchimp.com/icons/social-block-v2/outline-color-forwardtofriend-48.png"
                                                                    alt="Notre e-mail"
                                                                    height={24}
                                                                    width={24}
                                                                    style={{
                                                                      display:
                                                                        "block",
                                                                    }}
                                                                  />
                                                                </a>
                                                              </td>
                                                              <td
                                                                valign="middle"
                                                                className="mcnFollowTextContent"
                                                                style={{
                                                                  paddingLeft: 0,
                                                                  paddingBottom: 10,
                                                                }}
                                                              >
                                                                <a
                                                                  href="mailto:snap@unimes.fr"
                                                                  target="_blank"
                                                                  style={{
                                                                    color:
                                                                      "#656565",
                                                                  }}
                                                                >
                                                                  Notre e-mail
                                                                </a>
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                        <table
                                                          border={0}
                                                          cellPadding={0}
                                                          cellSpacing={0}
                                                          width="100%"
                                                          className="mcnFollowContentItem"
                                                        >
                                                          <tbody>
                                                            <tr>
                                                              <td
                                                                align="left"
                                                                valign="top"
                                                                width={24}
                                                                style={{
                                                                  paddingRight: 5,
                                                                  paddingLeft: 0,
                                                                  paddingBottom: 10,
                                                                }}
                                                                className="mcnFollowIconContent"
                                                              >
                                                                <a
                                                                  href="https://snap.unimes.fr/"
                                                                  target="_blank"
                                                                >
                                                                  <img
                                                                    src="https://cdn-images.mailchimp.com/icons/social-block-v2/outline-color-link-48.png"
                                                                    alt="Notre site"
                                                                    height={24}
                                                                    width={24}
                                                                    style={{
                                                                      display:
                                                                        "block",
                                                                    }}
                                                                  />
                                                                </a>
                                                              </td>
                                                              <td
                                                                valign="middle"
                                                                className="mcnFollowTextContent"
                                                                style={{
                                                                  paddingLeft: 0,
                                                                  paddingBottom: 10,
                                                                }}
                                                              >
                                                                <a
                                                                  href="https://snap.unimes.fr/"
                                                                  target="_blank"
                                                                  style={{
                                                                    color:
                                                                      "#656565",
                                                                  }}
                                                                >
                                                                  Notre site
                                                                </a>
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                        <table
                                                          border={0}
                                                          cellPadding={0}
                                                          cellSpacing={0}
                                                          width="100%"
                                                          className="mcnFollowContentItem"
                                                        >
                                                          <tbody>
                                                            <tr>
                                                              <td
                                                                align="left"
                                                                valign="top"
                                                                width={24}
                                                                style={{
                                                                  paddingRight: 5,
                                                                  paddingLeft: 0,
                                                                  paddingBottom: 0,
                                                                }}
                                                                className="mcnFollowIconContent"
                                                              >
                                                                <a
                                                                  href="https://demat.unimes.fr/snap"
                                                                  target="_blank"
                                                                >
                                                                  <img
                                                                    src="https://cdn-images.mailchimp.com/icons/social-block-v2/outline-color-link-48.png"
                                                                    alt="Formulaire d'assistance"
                                                                    height={24}
                                                                    width={24}
                                                                    style={{
                                                                      display:
                                                                        "block",
                                                                    }}
                                                                  />
                                                                </a>
                                                              </td>
                                                              <td
                                                                valign="middle"
                                                                className="mcnFollowTextContent"
                                                                style={{
                                                                  paddingLeft: 0,
                                                                  paddingBottom: 0,
                                                                }}
                                                              >
                                                                <a
                                                                  href="https://demat.unimes.fr/snap"
                                                                  target="_blank"
                                                                  style={{
                                                                    color:
                                                                      "#656565",
                                                                  }}
                                                                >
                                                                  Formulaire
                                                                  d'assistance
                                                                </a>
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width="100%"
                          className="mcnDividerBlock"
                          style={{ minWidth: "100%" }}
                        >
                          <tbody className="mcnDividerBlockOuter">
                            <tr>
                              <td
                                className="mcnDividerBlockInner"
                                style={{ minWidth: "100%", padding: 18 }}
                              >
                                <table
                                  className="mcnDividerContent"
                                  border={0}
                                  cellPadding={0}
                                  cellSpacing={0}
                                  width="100%"
                                  style={{
                                    minWidth: "100%",
                                    borderTop: "2px solid #EAEAEA",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <td>
                                        <span />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {/*            
          <td class="mcnDividerBlockInner" style="padding: 18px;">
          <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
*/}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
                {/*[if (gte mso 9)|(IE)]>
                  </td>
                  </tr>
                  </table>
                  <![endif]*/}
                {/* // END TEMPLATE */}
              </td>
            </tr>
          </tbody>
        </table>
      </center>
    </>
  );
}
